<div class="colors-container">
  <icn-color-component
    *ngFor="let colorField of colorFields"
    [colorField]="colorField"
  >
  </icn-color-component>
</div>
